import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../stores/Hooks';

export const ModalMessageError: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();
		const store = uiState.modal;
		return (
			<div className="modal-content">
				<p className="mb-0">{store.ModalErrorText}</p>
			</div>
		);
	}
)
